var _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3.6665,
    width: 16,
    height: 13.3333,
    rx: 1,
    stroke: "#EB662B",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.6665C1 4.72369 1 4.25229 1.29289 3.9594C1.58579 3.6665 2.05719 3.6665 3 3.6665H15C15.9428 3.6665 16.4142 3.6665 16.7071 3.9594C17 4.25229 17 4.72369 17 5.6665V7.22206H1V5.6665Z",
    fill: "#EB662B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55859 1L4.55859 3.66667",
    stroke: "#EB662B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4414 1L13.4414 3.66667",
    stroke: "#EB662B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.55859,
    y: 9,
    width: 3.55556,
    height: 1.77778,
    rx: 0.5,
    fill: "#EB662B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.55859,
    y: 12.5552,
    width: 3.55556,
    height: 1.77778,
    rx: 0.5,
    fill: "#EB662B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.88672,
    y: 9,
    width: 3.55556,
    height: 1.77778,
    rx: 0.5,
    fill: "#EB662B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.88672,
    y: 12.5552,
    width: 3.55556,
    height: 1.77778,
    rx: 0.5,
    fill: "#EB662B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender-icon.35a668fb3d5e356351dd72f117b334aa.svg";
export { ForwardRef as ReactComponent };